/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-betting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.47
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RankingStrategy
 */
export interface RankingStrategy {
    /**
     * 
     * @type {string}
     * @memberof RankingStrategy
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof RankingStrategy
     */
    isDefault: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RankingStrategy
     */
    _default?: boolean;
}

/**
 * Check if a given object implements the RankingStrategy interface.
 */
export function instanceOfRankingStrategy(value: object): value is RankingStrategy {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isDefault' in value) || value['isDefault'] === undefined) return false;
    return true;
}

export function RankingStrategyFromJSON(json: any): RankingStrategy {
    return RankingStrategyFromJSONTyped(json, false);
}

export function RankingStrategyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RankingStrategy {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'isDefault': json['isDefault'],
        '_default': json['default'] == null ? undefined : json['default'],
    };
}

export function RankingStrategyToJSON(value?: RankingStrategy | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'isDefault': value['isDefault'],
        'default': value['_default'],
    };
}

